var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SnackbarMessage',{attrs:{"show":_vm.showMessage,"color":_vm.color,"message":_vm.message},on:{"disable":function($event){_vm.showMessage = false; _vm.message = null; _vm.color = null}}})
}
var staticRenderFns = []

export { render, staticRenderFns }